var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenWhitepaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.0002 10.19H18.1102C15.7402 10.19 13.8102 8.26 13.8102 5.89V3C13.8102 2.45 13.3602 2 12.8102 2H8.57024C5.49024 2 3.00024 4 3.00024 7.57V16.43C3.00024 20 5.49024 22 8.57024 22H16.4302C19.5102 22 22.0002 20 22.0002 16.43V11.19C22.0002 10.64 21.5502 10.19 21.0002 10.19Z",
    fill: "#14A38B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3002 2.20999C15.8902 1.79999 15.1802 2.07999 15.1802 2.64999V6.13999C15.1802 7.59999 16.4202 8.80999 17.9302 8.80999C18.8802 8.81999 20.2002 8.81999 21.3302 8.81999C21.9002 8.81999 22.2002 8.14999 21.8002 7.74999C20.3602 6.29999 17.7802 3.68999 16.3002 2.20999Z",
    fill: "#14A38B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 13.75H8.00024C7.59024 13.75 7.25024 13.41 7.25024 13C7.25024 12.59 7.59024 12.25 8.00024 12.25H14.0002C14.4102 12.25 14.7502 12.59 14.7502 13C14.7502 13.41 14.4102 13.75 14.0002 13.75Z",
    fill: "#14A38B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 17.75H8.00024C7.59024 17.75 7.25024 17.41 7.25024 17C7.25024 16.59 7.59024 16.25 8.00024 16.25H12.0002C12.4102 16.25 12.7502 16.59 12.7502 17C12.7502 17.41 12.4102 17.75 12.0002 17.75Z",
    fill: "#14A38B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenWhitepaper);
export default __webpack_public_path__ + "static/media/greenWhitepaper.56c90e1ca23b9d2f62b7f842ad2fb418.svg";
export { ForwardRef as ReactComponent };